import gsap from "gsap/all";

export default function fadeElements() {

    let output = {};
    const durationIn = 0.8;
    const durationOut = 0.7;
    const yPercent = 50;

    output.fadeDefault = (element) => {
        gsap.set(element.target, { opacity: 0 });
    }

    output.fadeDefaultTop = (element) => {
        gsap.set(element.target, { opacity: 0, yPercent: yPercent });
    }

    output.fadeIn = (element) => {
        return gsap.to(element.target, {
            opacity: 1,
            delay: !element.delay ? 0 : element.delay,
            duration: !element.duration ? durationIn : element.duration
        });
    }

    output.fadeInTop = (element) => {
        return gsap.to(element.target, {
            opacity: 1,
            yPercent: 0,
            delay: !element.delay ? 0 : element.delay,
            duration: !element.duration ? durationIn : element.duration
        });
    }

    output.fadeOutBottom = (element) => {
        return gsap.to(element.target, {
            opacity: 0,
            yPercent: yPercent,
            delay: !element.delay ? 0 : element.delay,
            duration: !element.duration ? durationOut : element.duration
        });
    }

    return output;

}